import { CoreModule } from '@abp/ng.core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NonFcrCategoryDistributionWidgetComponent } from '../analysis-report/widgets/non-fcr-category-distribution-widget/non-fcr-category-distribution-widget.component';
import { AIDisclaimerModalComponent } from '../ai-disclaimer/ai-disclaimer-modal.component';
import { OperatorPipe } from 'src/core/pipes/operator.pipe';
import { CoreModule as CaCoreModule } from 'src/core/core.module';
import { QueryEditorModule } from '../query-editor/query-editor.module';
import { QueryMergeNodeModule } from '../query-editor/query-merge-node.module';

@NgModule({
  declarations: [
    NonFcrCategoryDistributionWidgetComponent,
    AIDisclaimerModalComponent,
  ],
  imports: [
    CoreModule,
    CaCoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    MatIconModule,
    MatButtonModule,
    QueryEditorModule,
    QueryMergeNodeModule,
  ],
  exports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    QueryEditorModule,
    QueryMergeNodeModule,
    NonFcrCategoryDistributionWidgetComponent,
  ],
  providers: [OperatorPipe],
})
export class SharedModule {}
